import { isTkeesDebugTheme } from "./theme";

if (isTkeesDebugTheme()) {
  console.log("[Tkees test theme] Redo loading pre-imports.");
}
